import { BLINDBOX_PRICE } from '@common/constans'
import { Button, Flex, Text } from '@library/uikit'
import getThemeValue from '@library/uikit/src/util/getThemeValue'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalTitle } from '@library/uikit/src/widgets/Modal'
import { useTranslation } from '@library/localization'
import React, { useEffect, useState } from 'react'
import { useProfile } from 'state/profile/hooks'
import { useTheme } from 'styled-components'

interface Props {
  onCharge: () => void
  onConfirm: () => void
  onDismiss?: () => void
}

const BlindBoxInfoModal: React.FC<Props> = ({ onCharge, onConfirm, onDismiss = () => null }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { profile } = useProfile()
  const [openBlindBoxTips, setOpenBlindBoxTips] = useState([])
  const balanceEnough = profile?.gold && profile?.gold > Number(BLINDBOX_PRICE)

  useEffect(() => {
    setOpenBlindBoxTips([t('Each address can only open a blind box once'), t('Five Gens in each blind box')])
  }, [t])

  return (
    <ModalContainer className="blindBoxModalContainer" minWidth="320px" minHeight="200px">
      <ModalHeader background={getThemeValue('colors.gradients.bubblegum')(theme)}>
        <ModalTitle>
          <Text fontSize="22px" fontWeight="bold">
            {t('Info')}
          </Text>
        </ModalTitle>
        <ModalCloseButton onDismiss={onDismiss} />
      </ModalHeader>
      <ModalBody alignItems="center" padding="24px">
        <Flex flexDirection="column" justifyContent="center">
          {openBlindBoxTips.map((tipItem, index) => {
            return (
              <li key={index}>
                <Text fontSize="18px" bold display="inline">
                  {tipItem}
                </Text>
              </li>
            )
          })}

          {!balanceEnough && (
            <Text mt={30} ml={20} fontWeight="bold" color="red">
              {t('G Cent not enough')}
            </Text>
          )}
        </Flex>
        <Button
          mt={24}
          scale="sm"
          variant="secondary"
          onClick={() => {
            onDismiss()
            if (!balanceEnough) {
              onCharge()
            } else {
              onConfirm()
            }
          }}
        >
          {balanceEnough ? t('Agree') : t('Charge')}
        </Button>
      </ModalBody>
    </ModalContainer>
  )
}

export default BlindBoxInfoModal
